<template>
  <div>
    <div>
      <b-modal
        id="voice-search-modal"
        v-model="modalShow"
        centered
        hide-header
        hide-footer
        ok-disabled
        cancel-disabled
      >
        <div class="d-block text-center modal-container">
          <div class="content-header">{{ $t('search.listening') }}...</div>
          <div class="content-body">
            <div class="image-mic">
              <svg
                aria-hidden="true"
                focusable="false"
                data-prefix="fas"
                data-icon="microphone"
                class="svg-inline--fa fa-microphone fa-w-11"
                role="img"
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 352 512"
              >
                <path
                  fill="currentColor"
                  d="M176 352c53.02 0 96-42.98 96-96V96c0-53.02-42.98-96-96-96S80 42.98 80 96v160c0 53.02 42.98 96 96 96zm160-160h-16c-8.84 0-16 7.16-16 16v48c0 74.8-64.49 134.82-140.79 127.38C96.71 376.89 48 317.11 48 250.3V208c0-8.84-7.16-16-16-16H16c-8.84 0-16 7.16-16 16v40.16c0 89.64 63.97 169.55 152 181.69V464H96c-8.84 0-16 7.16-16 16v16c0 8.84 7.16 16 16 16h160c8.84 0 16-7.16 16-16v-16c0-8.84-7.16-16-16-16h-56v-33.77C285.71 418.47 352 344.9 352 256v-48c0-8.84-7.16-16-16-16z"
                ></path>
              </svg>
            </div>
          </div>
          <div>
            <b-row class="buttons">
              <b-col>
                <div>
                  <so-close-button @click="handleClose">{{ $t('common.close') }}</so-close-button>
                </div>
              </b-col>
            </b-row>
          </div>
        </div>
      </b-modal>
    </div>
  </div>
</template>
<script>
import SoCloseButton from '@/components/common/SoCloseButton'

export default {
  name: 'VoiceSearchModal',
  components: {
    SoCloseButton,
  },
  computed: {
    modalShow: {
      get() {
        return this.$store.state.modal.showingVoiceSearchModal
      },
      set(value) {
        this.$store.commit('modal/setShowingVoiceSearchModal', value)
      },
    },
  },
  methods: {
    handleClose() {
      window.location.href = `${process.env.VUE_APP_BASE_CUSTOM_SCHEME}/open/stop_voice_input`
      this.$store.commit('modal/setShowingVoiceSearchModal', false)
    },
  },
}
</script>
<style lang="scss" scoped>
.modal-container {
  padding-top: 8px;
}
.content {
  color: #222222;

  &-header {
    font-size: 18px;
    font-weight: bold;
    text-indent: 1em;
  }

  &-body {
    display: flex;
    justify-content: center;
    color: #414141;
    padding: 32px 0 8px;

    .image-mic {
      position: relative;
      width: 100px;
      height: 100px;

      &::after {
        content: '';
        position: absolute;
        top: -50%;
        left: -50%;
        width: 200%;
        height: 200%;
        background: #414141;
        border-radius: 50%;
        animation: pulsate 1.2s ease-out;
        animation-iteration-count: infinite;
        opacity: 0.2;
        z-index: 1;
      }

      svg {
        position: relative;
        height: 100px;
        z-index: 2;
      }
    }
  }
}
@keyframes pulsate {
  0% {
    transform: scale(0.1, 0.1);
  }
  50% {
    opacity: 0.2;
  }
  100% {
    transform: scale(1, 1);
    opacity: 0;
  }
}
.col {
  padding-left: 4px;
  padding-right: 4px;
}
.buttons {
  margin-top: 20px;
}
</style>
